import React, { useState } from 'react'
import { GetSas, UpdateSas } from '@app/api/configuracoes';
import { Collapse, Icon, Tooltip } from 'antd'
import { Col, FormatText, FormInput, FormSubmitButton, FormSwitch, FormTextArea, MasterDetailForm, Row, usePromise, Widget } from '@digital/ui'
import { hasPermission } from '@app/helpers/permissions';
import CurrencyInput from '@app/components/CurrencyInput';
const { Panel } = Collapse

const ConfiguracaoSas = () => {
    const [update, setUpdate] = useState(false)
    const [dados] = usePromise(async () => await GetSas(), [update], {})

    const onUpdate = (values: any) => {
        UpdateSas(values).then(data => {
            if (data.valid) {
                setUpdate(!update)
            }
        })
    }

    return (
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="configuracoesSas" header="Parâmetros SAS">
                <MasterDetailForm
                    initialValues={dados}
                    onSubmit={onUpdate}
                >
                    <Widget
                        actions={[
                            hasPermission(['CONFIGURACAO_SAS_EDITAR']) && (
                                <FormSubmitButton noIcon={true} type="primary">
                                    <FormatText id="ui.commons.save" uppercase />
                                </FormSubmitButton>
                            )
                        ]}
                    >
                        <Row>
                            <label style={{ paddingLeft: '10px' }}>Mensagem valor mínimo para aprovação do Gerente Geral</label>
                            <Tooltip title="Mensagem a exibir de justificativa da aprovação de proponentes abaixo do mínimo previsto no Bid cycle.">
                                <Icon style={{ marginLeft: '4px' }} type="info-circle" />
                            </Tooltip>
                        </Row>
                        <Row >
                            <FormTextArea label="" name="sasValorMinimoAprovacaoGerenteGeral" span={4} rows={2} />
                        </Row>
                        <Row>
                            <CurrencyInput label="Valor Relatório Financeiro" name="sasValorConfide" span={3} />
                        </Row>
                        <Row>
                            <FormInput type='number' label="Percentual Margem Aprovada da OC (%)" name="sasPercentualMargemAprovada" span={3} />
                            <CurrencyInput label="Limite Máximo Variação da OC" name="sasLimiteMaximoVariacao" span={3} />
                        </Row>
                        <Row>
                            <CurrencyInput label="Minuta Simplificada" name="sasMinutaSimplificada" span={3} />
                        </Row>

                        <Row>
                            <Col span={3}>
                                <CurrencyInput label="Valor mínimo para realizar a etapa RH" name="sasValorMinimoRealizacaoRH"/>
                            </Col>
                            
                            <Col span={3}>
                                <CurrencyInput label="Valor máximo Gerente Departamento" name="sasValorMaximoGerenteDepartamento"/>
                            </Col>
                            
                            <Col span={3}>
                                <CurrencyInput label="Valor máximo Gerente Geral" name="sasValorMaximoGerenteGeral"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={3}/>
                            <Col span={3}>
                                <FormSwitch label="" name="sasValorMaximoGerenteDepartamentoHabilitado"/>
                            </Col>
                            <Col span={3}>
                                <FormSwitch label="" name="sasValorMaximoGerenteGeralHabilitado"/>
                            </Col>
                        </Row>
                    </Widget>
                </MasterDetailForm>
            </Panel>
        </Collapse>
    )
}

export default ConfiguracaoSas